import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { HiX } from "react-icons/hi";
import { FilterBar, FilterField } from "../common/FilterControls";

const DEFAULT_FILTERS = [
  { name: "Code", selector: "item_code" },
  { name: "Name", selector: "item_name" },
];

// filterColumns: the fields the search box looks in for this table (P115: each price list tab has its own)
const PriceListTable = ({ columns, data, categories, onItemAdded, filterColumns }) => {
  const [filterText, setFilterText] = useState("");

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  // the column the search starts in: the first one this table offers (it started on "item_code", which no option is
  // called, so the search filtered nothing until another column was picked)
  const [selectedColumn, setSelectedColumn] = useState((filterColumns || DEFAULT_FILTERS)[0].name);

  const allowedFilterColumns = filterColumns || DEFAULT_FILTERS;

  //   // Declare actionColumn first
  //   const actionColumn = {
  //     name: "Actions",
  //     cell: (row) => (
  //       <Menu as="div" className="relative">
  //         <Menu.Button className="sticky top-0">
  //           <HiDotsVertical className="w-6 h-6 text-gray-500 cursor-pointer" />
  //         </Menu.Button>
  //         <Transition
  //           enter="transition duration-100 ease-out"
  //           enterFrom="transform scale-95 opacity-0"
  //           enterTo="transform scale-100 opacity-100"
  //           leave="transition duration-75 ease-out"
  //           leaveFrom="transform scale-100 opacity-100"
  //           leaveTo="transform scale-95 opacity-0"
  //         >
  //           <Menu.Items className="absolute top-[-4vw] right-5 w-48 bg-white shadow-lg rounded-md ring-1 ring-black ring-opacity-5 focus:outline-none">
  //             {row.status === "Pending" && (
  //               <Menu.Item>
  //                 {({ active }) => {
  //                   const newStatus = row.status === "Pending" ? "Approved" : "";
  //                   return (
  //                     <button
  //                       className={`${
  //                         active ? "bg-blue-500 text-white" : "text-gray-900"
  //                       } group flex rounded-md items-center w-full px-4 py-2 text-sm md:text-[1vw]`}
  //                       onClick={() =>
  //                         setConfirmationModal({
  //                           text1: "Are you sure?",
  //                           text2: `You want to change status to ${newStatus}?`,
  //                           btn1Text: newStatus,
  //                           btn2Text: "Cancel",
  //                           btn1Handler: () => handleStatus(row, newStatus),
  //                           btn2Handler: () => setConfirmationModal(null),
  //                         })
  //                       }
  //                     >
  //                       Change Status
  //                     </button>
  //                   );
  //                 }}
  //               </Menu.Item>
  //             )}

  //             <Menu.Item>
  //               {({ active }) => (
  //                 <button
  //                   className={`${
  //                     active ? "bg-blue-500 text-white" : "text-gray-900"
  //                   } group flex rounded-md items-center w-full px-4 py-2 text-sm md:text-[1vw]`}
  //                   onClick={() => alert("Cancel clicked")}
  //                 >
  //                   Cancel
  //                 </button>
  //               )}
  //             </Menu.Item>
  //           </Menu.Items>
  //         </Transition>
  //       </Menu>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     right: true,
  //     style: {
  //       position: "sticky",
  //       right: "0px",
  //       zIndex: 1,
  //     },
  //   };

  // Now include actionColumn inside enhancedColumns
  const enhancedColumns = [...columns];

  // Function to get column value by either string key or selector function
  const getColumnValue = (row, selector) => {
    if (typeof selector === "function") {
      return selector(row);
    }
    return row[selector] || "";
  };

  // Filter data by the selected column and filter text
  const filteredData = data.filter((item) => {
    const column = allowedFilterColumns.find(
      (col) => col.name === selectedColumn
    );

    if (!column) {
      return true; // No filter if no column is selected
    }

    const valueToFilter = getColumnValue(item, column.selector)
      .toString()
      .toLowerCase();
    return valueToFilter.includes(filterText.toLowerCase());
  });

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  // Sub-header: pick the column, then type to filter it (SGEW 17 Oct: the shared filter-bar look - labelled, 38px high)
  const subHeaderComponent = (
    <FilterBar className="w-full py-2 text-left">
      <FilterField label="Search in" kind="select">
        <select
          className="sgew-control"
          value={selectedColumn}
          onChange={(e) => {
            setSelectedColumn(e.target.value);
            setFilterText(""); // Clear filter text when changing column
          }}
        >
          {allowedFilterColumns.map((col) => (
            <option key={col.selector} value={col.name}>
              {col.name}
            </option>
          ))}
        </select>
      </FilterField>
      <FilterField label="Search" kind="grow">
        <span className="relative block">
          <input
            className="sgew-control pr-8"
            type="text"
            placeholder={`Filter by ${selectedColumn}`}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
          {filterText && (
            <HiX
              className="absolute right-2.5 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
              onClick={handleClear}
            />
          )}
        </span>
      </FilterField>
    </FilterBar>
  );

  return (
    <div className="font-poppins">
      <div className="overflow-hidden !bg-white rounded-[0.42vw]">
        <DataTable
          columns={enhancedColumns}
          data={filteredData}
          pagination
          subHeader
          subHeaderComponent={subHeaderComponent}
          paginationResetDefaultPage={resetPaginationToggle}
          persistTableHead
          customStyles={{
            rows: {
              style: {
                minHeight: "60px",
                fontSize: "clamp(12px,0.93vw, 1rem)",
              },
            },
            headCells: {
              style: {
                fontWeight: 600,
                textAlign: "center",
                whiteSpace: "normal",
                fontSize: "clamp(14px, 1.1vw, 1.1rem)",
                color: "#10131e",
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default PriceListTable;
